import type { MenuButtonStoryblok } from "@/component-types-sb";
import { storyblokEditable } from "@storyblok/react";
import { clsx } from "clsx";
import { useParams } from "next/navigation";
import type { HTMLAttributes, MouseEvent } from "react";
import { ReactNode } from "react";

import { Button } from "@/components/layout/Button";

type MenuButtonProps = HTMLAttributes<HTMLElement> & {
  blok: MenuButtonStoryblok;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
};

const MenuButton = ({ blok, children, onClick, ...rest }: MenuButtonProps) => {
  const params = useParams();
  const lang = params.lang as string;
  const url =
    lang === "en" ? blok.link?.cached_url : `/${blok.link?.cached_url}`;

  return (
    <Button
      as="a"
      colorScheme="secondary"
      className={clsx(
        "m-2.5 transition-transform duration-300 h-6 text-xs lg:h-auto lg:text-normal",
        rest.className
      )}
      href={url || "#"}
      onClick={onClick}
      {...storyblokEditable(blok)}
    >
      {blok.name}
    </Button>
  );
};

export default MenuButton;
